import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import axios from "axios";

import { ArrowLeft, } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useLanguage } from "../../store/language-context";
import { useTranslation } from "react-i18next";

const DependenceiesSlider = () => {
    const { URL } = useLanguage();
    const { t } = useTranslation();
    const { data: dependencies = [], isLoading, error, refetch } = useQuery({
        queryKey: ['dependencies-slider', URL],
        queryFn: async () => {
            const response = await axios.get(`${URL}/dependencies?per_page=100`);
            if (response.status === 200) {
                return response?.data?.data?.data;
            } else {
                throw new Error(t('custom.err'));
            }
        },
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60 * 6, // 6HR
        gcTime: 1000 * 60 * 60 * 6,
    });
    return (
        <main className="container py-10 !mb-10">

            <div className="flex justify-center mb-4">
                <p className="services-header flex justify-center after:w-20">{t('routes.accreditations')}</p>
            </div>

            <section className="flex items-center justify-between gap-4">
                {isLoading ? (
                    <div className="w-full">
                        <div className="grid grid-cols-4 gap-5 max-2xl:grid-cols-2 max-lg:grid-cols-1 w-full">
                            {[...Array(4)].map((_, i) => (
                                <div
                                    key={i}
                                    className={`bg-white dependance-card w-full rounded transition overflow-hidden p-0 ${(i === 0) ? '' : 'max-lg:!hidden'}`}
                                    style={{
                                        borderRadius: "12px",
                                        margin: "10px 5px",
                                    }}
                                >
                                    <div className="rounded-card-image w-100"></div>
                                    <div className="rounded-card-img l-load"></div>
                                    <div className="flex justify-center items-center w-full my-3">
                                        <div className="w-32 h-3 rounded-lg l-load-dt"></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : error ? (
                    <div className="text-center py-8">
                            <p className="text-red-500">t('custom.err')</p>
                        <button
                            className="mt-2 bg-secondary-tw text-white px-4 py-2 rounded-md"
                            onClick={() => refetch && refetch()}
                        >
                                {t('custom.try-again')}
                        </button>
                    </div>
                ) : dependencies.length === 0 ? (
                    <p className="text-center py-8">{t('custom.no-data')}</p>
                ) : (
                    <Swiper
                        modules={[Navigation, Pagination, Autoplay]}
                        loop={true}
                        spaceBetween={30}
                        slidesPerView={4}
                        breakpoints={{
                            0: { slidesPerView: 1 },
                            680: { slidesPerView: 2 },
                            1000: { slidesPerView: 3 },
                            1200: { slidesPerView: 4 }
                        }}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                    >
                        {
                            dependencies.map((item, i) => (
                                <SwiperSlide key={i}>
                                    <div
                                        className="bg-white dependance-card w-full transition p-0 rounded-xl my-3 mx-1 h-80"
                                    >
                                        <div className="h-44 w-full">
                                            <div className="rounded-card-image w-100"></div>
                                            <img src={item?.image} alt={item?.name} className="rounded-card-img" />
                                        </div>
                                        <p className="text-lg p-text !px-4">{item?.title}</p>
                                        <Link to={`/dependencies/${item?.id}`} className="flex items-center !gap-1 ltr:flex-row-reverse text-primary-tw">
                                            {t('custom.show')} <span>
                                                <ArrowLeft/>
                                            </span>
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                )}

            </section>
            <div className="flex justify-center items-center gap-2 !my-4 ltr:flex-row-reverse">
                <Link to={'/dependencies'} className="text-black !underline !underline-offset-4">
                {t('custom.show-more')}
                </Link>
                <span>
                    <ArrowLeft size={20} className="mt-2" />
                </span>
            </div>
        </main>
    )
};

export default React.memo(DependenceiesSlider);